
import React, { useEffect } from 'react';
import { getEstimatedInstallationDuration } from '@/utils/installationUtils';

interface InstallationInfoSectionProps {
  customerName: string;
  selectedOffer: 'standard' | 'premium' | 'exclusive';
  needsMultipleUnits: boolean;
  numberOfRooms: number;
  squareArea: number;
}

const InstallationInfoSection: React.FC<InstallationInfoSectionProps> = ({
  customerName,
  selectedOffer,
  needsMultipleUnits,
  numberOfRooms,
  squareArea
}) => {
  console.log('InstallationInfoSection - input values:', { numberOfRooms, squareArea, selectedOffer });
  
  useEffect(() => {
    console.log('InstallationInfoSection useEffect - values:', { numberOfRooms, squareArea });
  }, [numberOfRooms, squareArea]);
  
  const installationDuration = getEstimatedInstallationDuration(numberOfRooms, squareArea, selectedOffer);
  console.log('InstallationInfoSection - calculated duration:', { installationDuration });

  return (
    <div className="space-y-2">
      <p className="text-gray-600">
        Witaj, <span className="font-medium">{customerName}</span>! Dziękujemy za wybór naszej firmy.
      </p>
      <p className="text-gray-600">
        Wybrany pakiet: <span className="font-medium">{selectedOffer === 'standard' ? 'Standard' : selectedOffer === 'premium' ? 'Premium' : 'Exclusive'}</span>.
      </p>
      <p className="text-gray-600">
        Szacowany czas trwania montażu: <span className="font-medium">{installationDuration}</span>.
      </p>
      {needsMultipleUnits && (
        <p className="text-orange-600">
          Ze względu na liczbę pokoi lub powierzchnię, montaż może wymagać więcej niż jednego urządzenia.
        </p>
      )}
    </div>
  );
};

export default InstallationInfoSection;
